import * as types from './types';

export const fetchData = () => ({
  type: types.FETCH_DATA,
});

export const updateConfig = payload => ({
  type: types.UPDATE_CONFIG,
  payload,
});

export const changeCustomisationModalVisibility = payload => ({
  type: types.CHANGE_CUSTOMISATION_MODAL_VISIBILITY,
  payload,
});

export const updateAiConfig = payload => ({
  type: types.UPDATE_AI_CONFIG,
  payload,
});

export const updateManualConfig = payload => ({
  type: types.UPDATE_MANUAL_CONFIG,
  payload,
});

export const verifyConfig = () => ({
  type: types.VERIFY_CONFIG,
});

export const saveConfig = () => ({
  type: types.SAVE_CONFIG,
});

export const clearConfig = () => ({
  type: types.CLEAR_CONFIG,
});

export const toggleVerifyDialog = payload => ({
  type: types.TOGGLE_VERIFY_DIALOG,
  payload,
});
